/**
 * Deterministic customer → colour mapping for schedule blocks.
 *
 * Connecteam-style: every customer gets the same colour every time so an
 * admin can scan the calendar and recognise customers at a glance. Colours
 * are picked from a 14-tone palette tuned for sufficient contrast against
 * white text and easy distinction between adjacent blocks.
 *
 * `null` / unassigned customer falls back to slate so internal / Lutrom-HQ
 * shifts read as muted-but-present.
 */
const PALETTE = [
  { bg: 'bg-blue-600',     ring: 'ring-blue-700',     soft: 'bg-blue-100 text-blue-900' },
  { bg: 'bg-emerald-600',  ring: 'ring-emerald-700',  soft: 'bg-emerald-100 text-emerald-900' },
  { bg: 'bg-violet-600',   ring: 'ring-violet-700',   soft: 'bg-violet-100 text-violet-900' },
  { bg: 'bg-rose-600',     ring: 'ring-rose-700',     soft: 'bg-rose-100 text-rose-900' },
  { bg: 'bg-amber-600',    ring: 'ring-amber-700',    soft: 'bg-amber-100 text-amber-900' },
  { bg: 'bg-cyan-600',     ring: 'ring-cyan-700',     soft: 'bg-cyan-100 text-cyan-900' },
  { bg: 'bg-fuchsia-600',  ring: 'ring-fuchsia-700',  soft: 'bg-fuchsia-100 text-fuchsia-900' },
  { bg: 'bg-teal-600',     ring: 'ring-teal-700',     soft: 'bg-teal-100 text-teal-900' },
  { bg: 'bg-indigo-600',   ring: 'ring-indigo-700',   soft: 'bg-indigo-100 text-indigo-900' },
  { bg: 'bg-orange-600',   ring: 'ring-orange-700',   soft: 'bg-orange-100 text-orange-900' },
  { bg: 'bg-lime-600',     ring: 'ring-lime-700',     soft: 'bg-lime-100 text-lime-900' },
  { bg: 'bg-pink-600',     ring: 'ring-pink-700',     soft: 'bg-pink-100 text-pink-900' },
  { bg: 'bg-sky-600',      ring: 'ring-sky-700',      soft: 'bg-sky-100 text-sky-900' },
  { bg: 'bg-purple-600',   ring: 'ring-purple-700',   soft: 'bg-purple-100 text-purple-900' },
];

const FALLBACK = { bg: 'bg-slate-700', ring: 'ring-slate-800', soft: 'bg-slate-100 text-slate-900' };

const hash = (str) => {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = ((h << 5) - h + str.charCodeAt(i)) | 0;
  return Math.abs(h);
};

export const colorForCustomer = (customerId) => {
  if (!customerId) return FALLBACK;
  return PALETTE[hash(customerId) % PALETTE.length];
};

/** Two letters max from the engineer's name. e.g. "Marcus Allen" → "MA". */
export const initialsFor = (name) => {
  if (!name) return '??';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '??';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};
